import { render } from "./FiColor.vue?vue&type=template&id=ff7d7b20"
import script from "./FiColor.vue?vue&type=script&lang=js"
export * from "./FiColor.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__